import React from "react";
import useDialogState from "../../hooks/useDialog";
import useMenuState, { useMenuState2 } from "../../hooks/useMenuState";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CountryCodeService from "../../services/countryCode.service";
import { useFormik } from "formik";
import { useMemo } from "react";
import { Button, Card, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { CircularProgress } from "@mui/material";
import { CountryCodeModal, DeleteCountryCode } from "../modals/allModal";
import countryFlag from "../../../assets/img/svgs/FLAG PLACEHOLDER.png";
import { useEffect } from "react";

const CountryCode = () => {
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const [data, setData] = useState([]);
  const [modalShowData, setModalShowData] = useState(false);
  const handleClose = () => setModalShowData(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [getSingleImage, setGetSingleImage] = useState("");
  const [dataPerPage, setDataPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getAllUser = async (page) => {
    try {
      setIsLoading(true);
      const response = await CountryCodeService.getAllCountryCode(
        search,
        page,
        dataPerPage
      );
      setTotalRows(response.data.totalCountry);
      setData(response.data.data);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllUser();
  }, [search]);

  const handelShow = (id, name) => {
    setModalShowData(true);
    setId(id);
    setName(name);
  };

  const initialValue = {
    countryName: "",
    countryCode: "",
    files: "",
  };

  const handleOpen = async (id) => {
    if (id) {
      handleDialogOpen();
      const response = await CountryCodeService.GetCountryCode(id);
      const result = response.data.data;
      formik.setFieldValue("id", result._id);
      formik.setFieldValue("countryName", result.countryName);
      formik.setFieldValue("countryCode", result.countryCode);
      formik.setFieldValue("files", result.countryImage);
      setGetSingleImage(result.countryImage);
    } else {
      handleDialogOpen();
      formik.setFieldValue("countryName", "");
      formik.setFieldValue("countryCode", "");
      formik.setFieldValue("files", "");
    }
  };

  const submit = async (values, action) => {
    const { id, countryCode, countryName, files } = values;
    if (values.id) {
      try {
        setLoader(true);
        const fileList = new FormData();
        fileList.append("files", files);
        await CountryCodeService.UpdateCountryCode(
          id,
          countryName,
          countryCode,
          fileList
        );
        setLoader(false);
        handleDialogClose();
        getAllUser();
        action.resetForm();
      } catch (error) {
        console.error("create race error", error);
        setLoader(false);
      }
    } else {
      try {
        const fileList = new FormData();
        fileList.append("files", files);
        setLoader(true);
        await CountryCodeService.AddCountryCode(
          countryName,
          countryCode,
          fileList
        );
        setLoader(false);
        handleDialogClose();
        getAllUser();
        action.resetForm();
      } catch (error) {
        console.error("create race error", error);
        setLoader(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const columns = [
    {
      name: <b>COUNTRY NAME</b>,
      selector: (row) => row.countryName,
      sortable: true,
    },
    {
      name: <b>COUNTRY CODE</b>,
      selector: (row) => "+" + row.countryCode,
      sortable: true,
    },
    {
      name: <b>COUNTRY IMAGE</b>,
      selector: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={row.countryImage ? row.countryImage : countryFlag}
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />
            </div>
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handelShow(row._id)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "150px",
    },
  ];

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );

  const handleChange = (file) => {
    const selectedFile = file.currentTarget.files[0];
    formik.setFieldValue("files", selectedFile);
  };

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setDataPerPage(newPerPage);
    await getAllUser();
  };

  const handlePageChange = async (newPageNumber) => {
    await getAllUser(newPageNumber);
  };
  const handleData = (e) => {
    setSearch(e.target.value);
  };
  return (
    <>
      {modalShowData && (
        <DeleteCountryCode
          show={modalShowData}
          onHide={handleClose}
          id={id}
          getAllUser={getAllUser}
          name={name}
        />
      )}
      <div>
        <div className="page-header2"></div>
        <div className="row">
          <Col sm={12} md={6} lg={6} xl={3}>
            <Card className="custom-card">
              <Card.Body>
                <div className="card-order ">
                  <label className="main-content-label font-weight-bold mb-3 pt-1">
                    Total Country Code
                  </label>
                  <h2 className="text-end card-item-icon card-icon">
                    <i className="mdi mdi-phone icon-size float-start text-primary"></i>
                    <span className="font-weight-bold">{totalRows}</span>
                  </h2>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col
            sm={12}
            md={6}
            lg={6}
            xl={4}
            className="ms-auto mt-auto d-flex"
            style={{ justifyContent: "end" }}>
            <div className="custom-card text-end  pointer me-5">
              <Button className="text-white" onClick={() => handleOpen("")}>
                <i className="fas fa-plus"></i> &nbsp; Add Country Code
              </Button>
            </div>
          </Col>
        </div>
        <div lg={12} className="w-100">
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <Card className="custom-card overflow-hidden">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginRight: "2px",
                        marginBottom: "10px",
                      }}>
                      <input
                        type="search"
                        style={{
                          border: "1px solid #e8e8f7",
                          padding: "0.375rem 0.75rem",
                          borderRadius: "7px",
                        }}
                        placeholder="Filter Table"
                        onChange={(e) => handleData(e)}
                      />
                    </div>
                    <DataTable
                      {...extensions}
                      data={data}
                      columns={columns}
                      noHeader
                      progressPending={isLoading}
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationRowsPerPageOptions={[5, 10, 50, 100]}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => {
                        handlePerPageChange(page, 1);
                      }}
                      onChangePage={handlePageChange}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </div>
                </Card>
              </div>
            </Card.Body>
          </Card>
        </div>
        {modalShows && (
          <CountryCodeModal
            show={handleDialogOpen}
            onHide={handleDialogClose}
            loader={loader}
            formik={formik}
            getSingleImage={getSingleImage}
            handleFileUpload={handleChange}
          />
        )}
      </div>
    </>
  );
};

export default CountryCode;
